import React from 'react';
import { useSelector } from 'react-redux';
import history from '../../history';
import { modal } from '../modal/ModalEmitter';
import PairTerminalForm from './PairTerminalForm';
import PaymentSetupForm from './PaymentSetupForm';

interface PaymentDashboardMenuItem {
  label: string;
  icon: JSX.Element;
  onClick: () => void;
  hidden?: boolean;
}

interface FAStyles extends React.CSSProperties {
  '--fa-secondary-color': string;
  '--fa-primary-color': string;
}

const iconStyle: FAStyles = { '--fa-secondary-color': 'limegreen', '--fa-primary-color': 'green' };
const defaultModalOptions = { headerClass: 'primary', hideFooter: true, hidePrint: true };

const PaymentDashboard = () => {
  const branch = useSelector((state: any) => state.app.branch);
  const nav = (route: string) => history.push(route);

  const renderIcon = (icon: string | JSX.Element) => {
    if (typeof icon === 'string') {
      return <i className={icon} />;
    }

    return icon;
  };

  const hasTerminalSupport = () => {
    return branch.payment && branch.payment.enabled && branch.payment.resellerName;
  };

  const menuItems: PaymentDashboardMenuItem[] = [
    {
      label: 'Payment Setup',
      icon: <i className="fad fa-money-bill-alt" style={iconStyle} />,
      onClick: () =>
        modal.open({
          ...defaultModalOptions,
          title: 'Payment Setup',
          message: (
            <PaymentSetupForm branchId={branch.id} onCancel={() => modal.close()} onSubmit={() => modal.close()} />
          ),
        }),
    },
    {
      label: 'Pair Terminal',
      icon: <i className="fad fa-plug" style={iconStyle} />,
      onClick: () => {
        modal.open({
          ...defaultModalOptions,
          title: 'Pair Terminal',
          message: <PairTerminalForm onCancel={() => modal.close()} onSubmit={() => modal.close()} />,
        });
      },
      hidden: !hasTerminalSupport(),
    },
    {
      label: 'Terminals',
      icon: <i className="fad fa-cash-register" style={iconStyle} />,
      onClick: () => nav('/UPY2'),
      hidden: !hasTerminalSupport(),
    },
    {
      label: 'Pending Payments',
      icon: <i className="fad fa-file-invoice-dollar" style={iconStyle} />,
      onClick: () => nav('/UPY5'),
      hidden: !hasTerminalSupport(),
    },
    {
      label: 'Card Transactions',
      icon: <i className="fad fa-credit-card" style={iconStyle} />,
      onClick: () => nav('/UPY3'),
      hidden: !hasTerminalSupport(),
    },
  ];

  if (process.env.NODE_ENV === 'development') {
    menuItems.push({
      label: 'Test',
      icon: <i className="fad fa-file-invoice-dollar" style={iconStyle} />,
      onClick: () => nav('/test/payment'),
    });
  }

  const renderMenuItems = () => {
    return menuItems.map((item, i) => {
      if (item.hidden) {
        return null;
      }

      return (
        <div className="crud-item-wrapper" key={i}>
          <div className="panel flex-panel crud-item list-item" onClick={item.onClick}>
            {renderIcon(item.icon)}
            {item.label}
          </div>
        </div>
      );
    });
  };

  return (
    <div className="payment-dashboard">
      <div id="dashboard">
        <div className="create-wrapper">{renderMenuItems()}</div>
      </div>
    </div>
  );
};

export default PaymentDashboard;
